import { render, staticRenderFns } from "./EditPurchaseInvoice.vue?vue&type=template&id=198f9f98&scoped=true&"
import script from "./EditPurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./EditPurchaseInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f9f98",
  null
  
)

export default component.exports